import React, { useEffect, useState } from 'react';
import IndividualSalesReportAPI from '../../../api/IndividualSalesReportAPI';
import '../../../components/common/Style.css';
import { reactLocalStorage } from 'reactjs-localstorage';
import Constants from '../../../util/Constants';
const IndividualReportBoxes = ({ filters }) => {
  const [lead, setLead] = useState(0);
  const [call, setCall] = useState(0);
  const [callTalktime, setCallTalktime] = useState(0);
  const [meeting, setMeeting] = useState(0);
  const [incoming, setIncoming] = useState(0);
  const [outgoing, setOutgoing] = useState(0);
  const directionOptions = reactLocalStorage.getObject(Constants.Model).call.fields.direction.options;
  const getLeads = () => {
    IndividualSalesReportAPI.getIndividualLeadsAllocated(
      filters,
      (res) => {
        const totalSums = res.reduce((acc, { sum }) => acc += sum, 0);
        setLead(totalSums);
      },
      handleFail
    );
  };
  const getCalls = () => {
    IndividualSalesReportAPI.getIndividualCall(
      filters,
      (res) => { 
        res && setCall(res[0]?.completed_count || 0); },
      handleFail
    );
  };
  const getCallTalkTime = () => {
    IndividualSalesReportAPI.getIndividualCallTalktime(
      filters,
      (res) => {
        const totalTalkTime = res.reduce((sum, item) => sum + item.sum, 0);
        setCallTalktime(totalTalkTime || 0);
      },
      handleFail
    );
  };
  const getMeetings = () => {
    IndividualSalesReportAPI.IndividualMeetingReport(
      filters,
      (res) => {
        const totalSums = res.reduce((acc, { completed_count }) => acc += completed_count, 0);
        setMeeting(totalSums);
      },
      handleFail
    );
  };
  const getIncomingOutgoingCall = () => {
    IndividualSalesReportAPI.getIndividualCallsInOut(
      filters,
      (res) => {
        const directionSums = directionOptions.reduce((acc, option) => {
          acc[option.value] = 0;
          return acc;
        }, {});
        res.forEach(item => {
          if (directionSums.hasOwnProperty(item.direction)) {
            directionSums[item.direction] = item.sum;
          }
        });
        setIncoming(directionSums['1']);
        setOutgoing(directionSums['2']);
      },
      handleFail
    );
  };

  const handleFail = () => {
    console.error("Failed to fetch data");
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  };

  useEffect(() => {
    getLeads();
    getCalls();
    getCallTalkTime();
    getMeetings();
    getIncomingOutgoingCall();
  }, []);

  return (
    <div className='container-fluid dashboard my-4  '>
      {/* <div className="row" > */}
      {/* <h2>Performance Detail</h2> */}
      {/* </div > */}
      <div className="row">
        <div className="card-group w-100">
          <div className="card text-white bg-primary mb-2 w-25" >
            <div className="card-header">Leads</div>
            <div className="card-body">
              <p className="card-text">{lead}</p>
            </div>
          </div>
          <div className="card text-white bg-info  mb-2 w-25" >
            <div className="card-header">Calls</div>
            <div className="card-body">
              <p className="card-text">{call}</p>
            </div>
          </div>
          <div className="card text-white bg-warning mb-2 w-25" >
            <div className="card-header"> Talktime</div>
            <div className="card-body">
              <p className="card-text">{formatTime(callTalktime)}</p>
            </div>
          </div>
          <div className="card text-white bg-success  mb-2 w-25" >
            <div className="card-header">Site Visits</div>
            <div className="card-body">
              <p className="card-text">{meeting}</p>
            </div>
          </div>
          <div className="card text-white bg-danger  mb-2 w-25" >
            <div className="card-header">Incoming Call</div>
            <div className="card-body">
              <p className="card-text">{incoming}</p>
            </div>
          </div>
          <div className="card text-white bg-primary  mb-2 w-25" >
            <div className="card-header">Outgoing Call</div>
            <div className="card-body">
              <p className="card-text">{outgoing}</p>
            </div>
          </div>
        </div>
      </div >
    </div >
  );
};

export default IndividualReportBoxes;